import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import TriggerEditor from 'app/developer-v3/pages/triggers/TriggerEditor/TriggerEditor';
import {
  currentTrigger,
  selectIsServiceSetup,
} from 'app/developer-v3/selectors';

const mapStateToProps = state => {
  const trigger = currentTrigger(state);

  return {
    currentUrl: RouterSelectors.currentUrl(state) || '',
    currentTriggerLabel: trigger?.display?.label ?? '',
    isTriggerSetup: selectIsServiceSetup(state),
  };
};

export default connect(mapStateToProps)(TriggerEditor);
